export enum IDs {
    BreakoutParticipantDragSvg = 'breakout-participant-drag-svg',
}
